<template>
<footer class="footer tg-footer" v-if="showStatus">
	<nav>
		<ul class="flex-container">
			<li v-for="item in items">
				<component :is="item.name" :current="(item.special?'special ':'')+($index===current?'current':'')" :scp="item.scp" @click="itemEvent($event,$index===current)"></component>
			</li>
		</ul>
	</nav>
</footer>
</template>

<script>
import components from '../menuItem/index.js';
import maple from 'maple';
import $ from 'jquery';
export default {
	methods:{
		itemEvent:function(e,current){
			if(current){
				e.preventDefault();
				e.stopPropagation();
			}
		}
	},
	props: {
		items: {
			type: Array
			, default: [{
                name:'gouwu'
                , scp:'navS.00'
            }, {
                name: 'overseas'
                , scp: 'navE.00'
            }, {
				name: 'store'
				, scp: 'navH.00'
			}, {
				name: 'shoppingCart'
				 , scp: 'navG.00'
			}, {
				name: 'member'
				, scp: 'navM.00'
			}]
		}
		, current: {
			type: Number
			, default: 0
		}
		, showStatus: {
			type: Boolean
			, default: !(maple.cookie('hybrid')==="true")
		}
	}
	, components: components
};
</script>

<style lang="scss">
	.footer{
		position: fixed;
		z-index: 10;
		bottom: 0;
		left: 0;
		right: 0;
		height: 49px;
		border-top: 1px solid #ccc;
		background: #fff;
	}
	.footer .flex-container{
		justify-content: space-around;
	}
	.footer li{
		min-width: 52px;
		margin-top: 3px;
		padding-top:1px;
	}
	.footer a{
		display: block;
		position: relative;
		/*margin-top: 31px;*/
		color: #000;
		font-size: 11px;
		line-height: 16px;
		text-align: center;
	}
	.footer .icon:before{
		/*position: absolute;*/
		/*top: -27px;*/
		/*left: 0;*/
		/*right: 0;*/
		margin: auto;
		font-size: 26px;
		line-height: 1;
		text-align: center;
	}
	/*.footer .current:after{
		content: ' ';
		position: absolute;
		top:-28px;
		right: 20%;
		background-color: #ff4c48;
		width: 6px;
		height: 6px;
		border-radius: 3px;
	}*/
	.footer span{
		/*margin-top: 31px;*/
		display: block;
	}
	.footer .special{
		width: 52px;
	}
	.footer .special.current span{
		color: #ff6565;
	}
	.footer .special .icon{
		position: absolute;
		top: -45px;
		left: 0;
		right: 0;
		height: 53px;
		width: 53px;
		border: 1px solid #ccc;
		border-radius: 50%;
		background: #fff;
	}
	.footer .special .icon:before{
		position: absolute;
		z-index: 1;
		top: 5px;
		height: 41px;
		width: 41px;
		border-radius: 50%;
		/*margin: 5px;*/
		background: #16cc90;
		color: #fff;
		line-height: 41px;
		font-size: 24px;
	}
	.footer .special .icon:after{
		position: absolute;
		z-index: 0;
		top: 12px;
		left: -1px;
		right: -1px;
		height: 45px;
		margin: auto;
		background: #fff;
		content: "";
	}
	.footer .special span{
		position: relative;
		z-index: 1;
	}
	.footer sub{
		position: absolute;
		top: -20px;
		right: 10px;
		height: 5px;
		width: 5px;
		border-radius: 50%;
		background: #fc6668;
	}
</style>